import React, { Component } from 'react'
import { GridArea as GridAreaStyled } from 'ui/layout/grid'
import PropTypes from 'prop-types'
import Decorator from 'decorators/Decorator'

export default class GridArea extends Component {
  render () {
    const {
      props: {
        children
      }
    } = this

    return (
      <Decorator {...this.props}>
        <GridAreaStyled>
          {children}
        </GridAreaStyled>
      </Decorator>
    )
  }

  static propTypes = {
    children: PropTypes.node.isRequired,
    name: PropTypes.string.isRequired
  }

}
